export const INIT_VALUES = 'BodyFilterModal/init-values';
export const CLEAR_SELECTIONS = 'BodyFilterModal/clear-selections';
export const SET_TRANSIENT_VALUES = 'CreateEditCampaign/set-transient-values';
export const APPLY_VALUES = 'BodyFilterModal/apply-values';

export const STORES_FOR_MAPPING_LOADING = 'BodyFilterModal/stores-for-mapping-loading';
export const PRODUCTS_FOR_MAPPING_LOADING = 'BodyFilterModal/products-for-mapping-loadin';
